var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"grid"},_vm._l((_vm.groups),function(apps,index){return _c('app-store-grid-row',{key:index,attrs:{"heading":index,"apps":apps}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }